/**
 * tech.ts — Categoría "Tecnología" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_tech",
  skuPrefix: "TEC",
  categoria: "Tecnología",
} as const;

export const cat_tech_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Smartphone iPhone 15",
    marca: "Apple",
    modelo: "iPhone 15 128GB",
    origen: "China",
    costo: 3850000,
    precio: 5790000,
    stock: 15,
    stockMinimo: 5,
    stockMaximo: 30,
    unidad: "unidad",
    ubicacionFisica: "Vitrina T1",
    proveedor: "Apple Colombia",
    garantia: "1 año",
    material: "Aluminio aeroespacial",
    colorProducto: "Negro medianoche",
    dimensiones: "147x71x7.8mm",
    descripcionLarga:
      'iPhone 15 con chip A16 Bionic, cámara 48MP, pantalla Super Retina XDR 6.1", USB-C. 128GB almacenamiento.',
    especificaciones: [
      { clave: "Chip", valor: "A16 Bionic" },
      { clave: "Almacenamiento", valor: "128GB" },
      { clave: "Pantalla", valor: '6.1" OLED' },
    ],
    imageKeywords: ["iphone-15", "smartphone-apple", "iphone"],
    color: "bg-slate-900",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Samsung Galaxy S24",
    marca: "Samsung",
    modelo: "Galaxy S24 256GB",
    origen: "Vietnam",
    costo: 2950000,
    precio: 4490000,
    stock: 18,
    stockMinimo: 5,
    stockMaximo: 36,
    unidad: "unidad",
    ubicacionFisica: "Vitrina T1",
    proveedor: "Samsung Electronics Colombia",
    garantia: "1 año",
    material: "Aluminio + Gorilla Glass",
    colorProducto: "Negro ónix",
    descripcionLarga:
      'Galaxy S24 con Snapdragon 8 Gen 3, pantalla Dynamic AMOLED 6.2" 120Hz, cámara 50MP, Galaxy AI integrado.',
    especificaciones: [
      { clave: "Procesador", valor: "Snapdragon 8 Gen 3" },
      { clave: "RAM", valor: "8GB" },
      { clave: "Almacenamiento", valor: "256GB" },
    ],
    imageKeywords: ["galaxy-s24", "samsung-phone", "android-phone"],
    color: "bg-slate-900",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Laptop Lenovo ThinkPad",
    marca: "Lenovo",
    modelo: "ThinkPad E14 Gen 4",
    origen: "China",
    costo: 3450000,
    precio: 5290000,
    stock: 10,
    stockMinimo: 3,
    stockMaximo: 20,
    unidad: "unidad",
    ubicacionFisica: "Vitrina T2",
    proveedor: "Lenovo Colombia",
    garantia: "3 años",
    material: "Aluminio reciclado",
    colorProducto: "Negro",
    descripcionLarga:
      'Laptop empresarial 14" con Intel Core i7-1255U, 16GB RAM DDR4, SSD 512GB, Windows 11 Pro. Certificación militar.',
    especificaciones: [
      { clave: "Procesador", valor: "i7-1255U" },
      { clave: "RAM", valor: "16GB DDR4" },
      { clave: "SSD", valor: "512GB" },
    ],
    imageKeywords: ["laptop", "thinkpad", "lenovo-laptop"],
    color: "bg-slate-900",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: 'TV 55" 4K Smart',
    marca: "Samsung",
    modelo: "UN55AU7000",
    origen: "México",
    costo: 1850000,
    precio: 2790000,
    stock: 12,
    stockMinimo: 3,
    stockMaximo: 24,
    unidad: "unidad",
    ubicacionFisica: "Vitrina T3",
    proveedor: "Samsung Electronics Colombia",
    garantia: "2 años",
    tiempoEntrega: "5 días",
    material: "Plástico y metal",
    colorProducto: "Negro",
    dimensiones: "55 pulgadas",
    descripcionLarga:
      'Smart TV LED 55" 4K UHD con Tizen OS, HDR10+, 3 HDMI, WiFi y Bluetooth. Control remoto universal.',
    especificaciones: [
      { clave: "Tamaño", valor: '55"' },
      { clave: "Resolución", valor: "4K UHD" },
      { clave: "Smart", valor: "Tizen OS" },
    ],
    imageKeywords: ["smart-tv", "4k-tv", "samsung-tv"],
    color: "bg-slate-900",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Audífonos Sony WH-1000XM5",
    marca: "Sony",
    modelo: "WH-1000XM5",
    origen: "Tailandia",
    costo: 1250000,
    precio: 1890000,
    stock: 15,
    stockMinimo: 4,
    stockMaximo: 30,
    unidad: "unidad",
    ubicacionFisica: "Vitrina T4",
    proveedor: "Sony Colombia",
    garantia: "1 año",
    material: "Plástico reciclado y cuero sintético",
    colorProducto: "Negro",
    descripcionLarga:
      "Audífonos over-ear premium con cancelación ruido líder, Hi-Res audio, 30h batería, carga rápida USB-C.",
    especificaciones: [
      { clave: "Autonomía", valor: "30h" },
      { clave: "ANC", valor: "Sí" },
    ],
    imageKeywords: ["sony-headphones", "wireless-headphones", "wh1000xm5"],
    color: "bg-slate-900",
    shape: "circle",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Airpods Pro 2",
    marca: "Apple",
    modelo: "AirPods Pro 2nd Gen",
    origen: "China",
    costo: 785000,
    precio: 1199000,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "unidad",
    ubicacionFisica: "Vitrina T4",
    proveedor: "Apple Colombia",
    garantia: "1 año",
    material: "Plástico ABS",
    colorProducto: "Blanco",
    descripcionLarga:
      "AirPods Pro 2 con chip H2, cancelación activa ruido 2x mejor, modo transparencia adaptativa, estuche USB-C.",
    especificaciones: [
      { clave: "Chip", valor: "H2" },
      { clave: "Autonomía", valor: "6h + 30h estuche" },
    ],
    imageKeywords: ["airpods-pro", "apple-earbuds", "wireless-earphones"],
    color: "bg-white",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Smartwatch Apple Watch",
    marca: "Apple",
    modelo: "Watch Series 9 45mm",
    origen: "China",
    costo: 1650000,
    precio: 2490000,
    stock: 14,
    stockMinimo: 4,
    stockMaximo: 28,
    unidad: "unidad",
    ubicacionFisica: "Vitrina T1",
    proveedor: "Apple Colombia",
    garantia: "1 año",
    material: "Aluminio + correa sport",
    colorProducto: "Medianoche",
    dimensiones: "45mm",
    descripcionLarga:
      "Apple Watch Series 9 GPS 45mm, chip S9, siempre activa Retina, detección caída, ECG, SpO2.",
    especificaciones: [
      { clave: "Chip", valor: "S9" },
      { clave: "Tamaño", valor: "45mm" },
    ],
    imageKeywords: ["apple-watch", "smartwatch", "fitness-watch"],
    color: "bg-slate-900",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: 'iPad Air 11"',
    marca: "Apple",
    modelo: "iPad Air M2 128GB WiFi",
    origen: "China",
    costo: 2850000,
    precio: 4290000,
    stock: 10,
    stockMinimo: 3,
    stockMaximo: 20,
    unidad: "unidad",
    ubicacionFisica: "Vitrina T2",
    proveedor: "Apple Colombia",
    garantia: "1 año",
    material: "Aluminio reciclado",
    colorProducto: "Azul",
    descripcionLarga:
      'iPad Air 11" con chip M2, pantalla Liquid Retina, Apple Pencil Pro compatible, 128GB, WiFi 6E.',
    especificaciones: [
      { clave: "Chip", valor: "M2" },
      { clave: "Pantalla", valor: '11" Liquid Retina' },
    ],
    imageKeywords: ["ipad-air", "apple-tablet", "ipad"],
    color: "bg-blue-500",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Consola PlayStation 5",
    marca: "Sony",
    modelo: "PS5 Slim Digital",
    origen: "Japón",
    costo: 2250000,
    precio: 3390000,
    stock: 8,
    stockMinimo: 2,
    stockMaximo: 16,
    unidad: "unidad",
    ubicacionFisica: "Vitrina T5",
    proveedor: "Sony Colombia",
    garantia: "1 año",
    material: "Plástico ABS",
    colorProducto: "Blanco",
    descripcionLarga:
      "PlayStation 5 Slim edición digital, CPU AMD Zen 2, GPU RDNA 2, SSD 1TB, soporta juegos 4K 120fps.",
    especificaciones: [
      { clave: "Almacenamiento", valor: "1TB SSD" },
      { clave: "Resolución", valor: "Hasta 4K 120fps" },
    ],
    imageKeywords: ["playstation-5", "ps5", "gaming-console"],
    color: "bg-white",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Mouse Gaming Logitech",
    marca: "Logitech",
    modelo: "G Pro X Superlight",
    origen: "China",
    costo: 485000,
    precio: 749000,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "unidad",
    ubicacionFisica: "Vitrina T6",
    proveedor: "Logitech Colombia",
    garantia: "2 años",
    material: "Plástico ABS",
    colorProducto: "Negro",
    descripcionLarga:
      "Mouse gaming inalámbrico ultra ligero 63g, sensor HERO 25K, Lightspeed, 70h batería.",
    especificaciones: [
      { clave: "Peso", valor: "63g" },
      { clave: "DPI", valor: "25.600" },
    ],
    imageKeywords: ["gaming-mouse", "logitech-mouse", "esports-mouse"],
    color: "bg-slate-900",
    shape: "circle",
  }),
];
